<template>
  <div class="officeSaff-container">
    <!-- <v-header title="候选人清单"></v-header> -->
    <el-container class="container" v-if="show">
      <el-header class="search-form">
        <div class="search-header">查询条件</div>
        <div>
          <label class="title">机构：</label>
          <el-cascader
            v-model="queryParams.organCodes"
            :options="manageComNameOptions"
            :props="cascaderProps"
            :show-all-levels="false"
            clearable
            size="mini"
            placeholder="请选择机构"
            @change="handleChange"
          >
          </el-cascader>
        </div>
        <div>
          <label class="title">候选人证件类型：</label>
          <el-select
            size="mini"
            v-model="queryParams.certType"
            clearable
            placeholder="请选择证件类型"
          >
            <el-option
              v-for="item in idTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div>
          <label class="title">候选人证件号码：</label>
          <el-input
            size="mini"
            v-model="queryParams.certCode"
            @input="
              queryParams.certCode = queryParams.certCode.replace(
                /[^a-zA-Z0-9\u4E00-\u9FA5]/g,
                ''
              )
            "
            maxlength="20"
            clearable
            placeholder="请输入证件号码"
          ></el-input>
        </div>
        <div>
          <label class="title">候选人姓名：</label>
          <el-input
            size="mini"
            v-model="queryParams.accountName"
            @input="
              queryParams.accountName = queryParams.accountName.replace(
                /[^a-zA-Z0-9\u4E00-\u9FA5]/g,
                ''
              )
            "
            maxlength="20"
            clearable
            placeholder="请输入姓名"
          ></el-input>
        </div>
        <div>
          <label class="title">候选人电话：</label>
          <el-input
            size="mini"
            v-model="queryParams.accountMobile"
            @input="
              queryParams.accountMobile = queryParams.accountMobile.replace(
                /[^0-9]/g,
                ''
              )
            "
            maxlength="11"
            clearable
            placeholder="请输入"
          ></el-input>
        </div>
        <div>
          <label class="title">推荐人姓名：</label>
          <el-input
            size="mini"
            v-model="queryParams.recomAgent"
            @input="
              queryParams.recomAgent = queryParams.recomAgent.replace(
                /[^a-zA-Z\u4E00-\u9FA5]/g,
                ''
              )
            "
            maxlength="30"
            clearable
            placeholder="请输入姓名"
          ></el-input>
        </div>
        <div>
          <label class="title">查询类型：</label>
          <el-radio-group v-model="queryParams.stepType" size="mini">
            <el-radio label="1">当前阶段</el-radio>
            <el-radio label="2">经过阶段</el-radio>
          </el-radio-group>
          <el-select
            size="mini"
            v-model="queryParams.lifeNodes"
            multiple
            clearable
            placeholder="全部"
          >
            <el-option
              v-for="item in stepOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div>
          <label class="title">时间范围：</label>
          <el-date-picker
            size="mini"
            v-model="queryParams.dateRange"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="to"
            start-placeholder="开始"
            end-placeholder="截至"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </div>
      </el-header>
      <div style="margin-top: 10px;padding-left: 20px;">
        <template v-if="currentRouteType == '1'">
          <el-button type="primary" size="mini" @click="arrangeFunc" style="background-color: #194793;border: none;"
            >人员安排</el-button
          >
        </template>
        <template v-if="currentRouteType == '4'">
          <el-button type="primary" size="mini" @click="editStateFunc"
            >人员招募状态修改</el-button
          >
        </template>
        <template v-if="currentRouteType == '2' || currentRouteType == '3'">
          <el-button
            type="primary"
            size="mini"
            @click="batchOperateFunc('sure')"
            >{{ currentRouteType == "2" ? "批量确认" : "批量通过" }}</el-button
          >
          <el-button
            type="primary"
            size="mini"
            @click="batchOperateFunc('return')"
            >批量退回</el-button
          >
        </template>
        <template v-if="currentRouteType != '2'">
          <el-button type="primary" size="mini" @click="exportFunc" style="background-color: #194793;border: none;"
            >人员导出</el-button
          >
        </template>
        <span style="float: right;">
          <!-- #d2bb8b金色 #194793蓝色-->
          <el-button type="primary" size="mini" @click="searchFunc" style="background-color: #d2bb8b;border: none;">查询</el-button>
          <el-button type="info" size="mini" @click="resetFunc" style="background-color: #d2bb8b;border: none;">重置</el-button>
        </span>
      </div>
      <el-main class="table-container">
        <el-table
          v-loading="loading"
          element-loading-text="加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          :data="tableData"
          border
          :cell-style="tableCellStyle"
          :header-cell-style="tableHeaderColor"
          stripe
          style="width: 100%"
          height="100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            fixed
            align="center"
            type="index"
            label="序号"
            width="50"
          >
          </el-table-column>
          <el-table-column fixed align="center" type="selection" width="55">
          </el-table-column>
          <el-table-column
            fixed
            align="center"
            prop="branch"
            width="100"
            show-overflow-tooltip
            label="分公司"
          >
          </el-table-column>
          <el-table-column
            fixed
            align="center"
            prop="organ"
            width="100"
            show-overflow-tooltip
            label="T3机构"
          >
          </el-table-column>
          <el-table-column
            fixed
            align="center"
            prop="area"
            width="130"
            show-overflow-tooltip
            label="T4机构"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="accountName"
            width="80"
            show-overflow-tooltip
            label="姓名"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="certType"
            show-overflow-tooltip
            label="证件类型"
          >
            <template slot-scope="scope" v-if="scope.row.certType">
              {{
                idTypeOptions.find((ite) => ite.value == scope.row.certType)
                  .label
              }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="certCode"
            width="130"
            show-overflow-tooltip
            label="证件号码"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="mobile"
            width="110"
            show-overflow-tooltip
            label="手机号"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="comprehensiveScore"
            show-overflow-tooltip
            label="综合评分"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="sexDesc"
            width="50"
            show-overflow-tooltip
            label="性别"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="age"
            width="50"
            show-overflow-tooltip
            label="年龄"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="education"
            width="50"
            show-overflow-tooltip
            label="学历"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="lifeNodeDesc"
            width="120"
            show-overflow-tooltip
            label="当前阶段"
          >
            <template slot-scope="scope">
              <el-link type="primary" @click="viewDetailsFunc(scope.row, 2)">
                {{ scope.row.lifeNodeDesc }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="lifeNodeTime"
            width="140"
            show-overflow-tooltip
            label="当前阶段时间"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="reference"
            width="130"
            show-overflow-tooltip
            label="推荐人"
          >
          </el-table-column>
          <el-table-column
            align="center"
            width="350"
            label="操作"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="viewDetailsFunc(scope.row)"
                >查看</el-button
              >
              <el-button
                v-if="
                  scope.row.lifeNode != 14 &&
                  scope.row.lifeNode < 17 &&
                  currentRouteType == '1'
                "
                type="text"
                @click="editRowFunc(scope.row)"
                >修改</el-button
              >
              <template v-if="currentRouteType == '1'">
                <el-button
                  v-if="showRowBtn(scope.row, 'arrangeSingle')"
                  type="text"
                  @click="arrangeSingleFunc(scope.row)"
                  >安排</el-button
                >
                <el-button
                  v-if="showRowBtn(scope.row, 'replace')"
                  type="text"
                  @click="replaceFunc(scope.row)"
                  >更换面试人员</el-button
                >
                <el-button
                  v-if="showRowBtn(scope.row, 'other')"
                  type="text"
                  @click="otherFunc(scope.row)"
                  >其他操作</el-button
                >
              </template>
              <template
                v-if="
                  (currentRouteType == '2' && scope.row.lifeNode == '11') ||
                  (currentRouteType == '3' && scope.row.lifeNode == '13')
                "
              >
                <el-button
                  type="text"
                  @click="operateSingleFunc(scope.row, 'sure')"
                  >{{ currentRouteType == "2" ? "确认" : "通过" }}</el-button
                >
                <el-button
                  type="text"
                  @click="operateSingleFunc(scope.row, 'return')"
                  >退回</el-button
                >
              </template>
              <template v-if="currentRouteType == '4'">
                <el-button type="text" @click="editStateSingleFunc(scope.row)"
                  >状态修改</el-button
                >
              </template>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="queryParams.pageNum"
          :page-size="20"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </el-footer>
    </el-container>
    <div class="container detail-container" v-if="!show">
      <!--  -->
      <detail
        :accountData="accountResumeDetail"
        :tab="tabVal"
        :currentRouteType="currentRouteType"
        @operateSingleFunc="operateSingleFunc"
        @back="show = true"
        :states="pageStates"
      />
    </div>
    <!-- 其他操作-作废面试 -->
    <operate-dialog
      v-if="operateDialogVisible"
      @close="operateDialogVisible = false"
      :detailObj="operateRowData"
      @refresh="resetFunc"
    />
    <!-- 机构/分工公司确认(审核)退回123 -->
    <re-interview-dialog
      v-if="reInterviewDialogVisible"
      :currentRouteType="currentRouteType"
      :btnType="reInterviewBtnType"
      :title="operateTitle"
      :detailList="reInterviewRowData"
      @close="reInterviewDialogVisible = false"
      @refresh="resetFunc"
    />
    <!--人员安排-->
    <arrange-dialog
      v-if="arrangeDialogVisible"
      :detailList="arrangeSingRowData"
      @close="arrangeDialogVisible = false"
      @refresh="resetFunc"
    />
    <!-- 更换面试官 -->
    <replace-interviewer-dialog
      v-if="replaceInterviewerDialogVisible"
      :detailObj="replaceInterviewerRowData"
      @close="replaceInterviewerDialogVisible = false"
      @refresh="resetFunc"
    />
    <!-- 招募状态修改 -->
    <edit-state-dialog
      v-if="editStateDialogVisible"
      :detailList="editStateRowData"
      @close="editStateDialogVisible = false"
      @refresh="resetFunc"
    />
  </div>
</template>

<script>
import url from "@/modules/url";
import api from "@/modules/api";
// import vHeader from "@/layout/Header1.vue";
import detail from "./detail.vue";
import reInterviewDialog from "./component/reInterviewDialog.vue"; // 机构/分工公司确认(审核)退回
import arrangeDialog from "./component/arrangeDialog.vue"; // 人员安排
import replaceInterviewerDialog from "./component/replaceInterviewerDialog.vue"; // 更换面试官
import operateDialog from "./component/operateDialog.vue"; // 其他操作-作废面试
import editStateDialog from "./component/editStateDialog.vue"; // 招募状态修改
import tableBaseCss from "../tableBaseCss";
import { Options } from "@/components/utils/fixOptions";
let currentPage = "";
export default {
  name: currentPage,
  components: {
    detail,
    reInterviewDialog,
    arrangeDialog,
    replaceInterviewerDialog,
    operateDialog,
    editStateDialog,
  },
  mixins: [tableBaseCss],
  data() {
    return {
      editStateRowData: [],
      editStateDialogVisible: false,
      accountResumeDetail: {},
      operateDialogVisible: false,
      operateRowData: {},
      replaceInterviewerDialogVisible: false,
      replaceInterviewerRowData: {},
      reInterviewDialogVisible: false,
      operateTitle: "",
      reInterviewRowData: [],
      reInterviewBtnType: "",
      arrangeDialogVisible: false,
      arrangeSingRowData: [],
      idTypeOptions: Options.id_type, // 存储证件类型下拉菜单数据的集合
      stepOptions: Options.step_all_status,
      editable: false,
      show: true, // 区分显示表示数据模块还是显示数据详情模块的变量
      token: "", // 设置存储token的变量
      tabVal: 0, // 详情页面tab值
      // 定义查询条件的参数对象
      queryParams: {
        organCodes: [], // 机构编码
        certType: "", // 候选人证件类型
        certCode: "", // 候选人证件号码
        accountName: "", // 候选人姓名
        accountMobile: "", // 候选人联系电话
        recomAgent: "", // 推荐人姓名
        stepType: "1", //
        lifeNodes: [], //查询类型
        dateRange: [],
        pageNum: 1, // 每页展示的数据条数
        pageSize: 20, // 页码数，初始化默认为'1'
      },
      tableData: [], // 定义存储表格数据的集合
      total: 0, // 数据总条数
      loading: false, // 定义是否开启表格的加载遮罩的变量
      cascaderProps: {
        multiple: true,
        value: "code", // 指定 value 字段
        label: "name", // 指定 label 字段
        children: "childList", // 指定 children 字段
      },
      manageComNameOptions: [], // 存储机构下拉菜单数据的集合
      pickerOptions() {
        const [start, end] = this.dateRange || [];
        return {
          disabledDate: (time) => {
            const today = new Date();
            today.setHours(0, 0, 0, 0); // 如果你想禁用今天之前的时间，也可以在这里控制

            if (start && !end) {
              // 已选开始日期，限制结束日期 >= 开始日期
              return time.getTime() < new Date(start).getTime();
            } else if (!start && end) {
              // 已选结束日期，限制开始日期 <= 结束日期
              return time.getTime() > new Date(end).getTime();
            }
            // 示例：不允许选择今天之前的日期（如不需要，可删掉）
            // return time.getTime() < today.getTime();
            return false;
          },
        };
      },
      detailsObj: {},
      pageStates: "",
      multipleSelection: [], // 存储选中的数据
      currentRouteType: "",
    };
  },
  mounted() {
    const path = this.$route.path;
    const lastSegment = path.substring(path.lastIndexOf("/") + 1);
    currentPage = lastSegment;
    this.currentRouteType = this.getPageType(currentPage);
    this.loading = true;
    this.getCookieData();
    this.getManageComNameSelectDataFunc();

    setTimeout(() => {
      // 调用查询获取表格数据的方法
      this.queryDataFunc("init");
    }, 1500);
  },
  methods: {
    getPageType(val) {
      let type = "";
      switch (val) {
        case "orgLeader":
          type = "2";
          break;
        case "branchOffice":
          type = "3";
          break;
        case "headOffice":
          type = "4";
          break;
        default:
          type = "1";
      }
      return type;
    },
    // 操作table数据选择多行时使用Checkbox。
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(val, "Checkbox====val");
    },
    // 查看详情
    viewDetailsFunc(rowData, tab) {
      if (tab === 2) {
        this.tabVal = tab;
      }
      this.pageStates = "";
      this.accountResumeDetail = rowData;
      this.show = false;
      console.log(this.accountResumeDetail, "查看详情====");
      // this.getDetail(rowData.userId)
    },
    // getDetail(id){
    //   api.post(url.getAccountResume, {id: id}, (res) => {
    //     if (res.result.isSuccess) {
    //       this.accountResumeDetail = res.data
    //       this.show = false;
    //     } else {
    //       if (res.result.errors.length > 0) {
    //         this.$message({
    //           type: 'error',
    //           message: res.result.errors[0].errorCode + res.result.errors[0].error
    //         });
    //       } else {
    //         this.$message({
    //           type: 'error',
    //           message: res.result.error
    //         });
    //       }
    //     }
    //   });
    // },

    // 修改
    editRowFunc(rowData) {
      this.pageStates = "edit";
      this.accountResumeDetail = rowData;
      this.show = false;
      // this.getDetail(rowData.userId)
    },
    // 安排
    arrangeSingleFunc(rowData) {
      this.arrangeSingRowData = [rowData];
      this.arrangeDialogVisible = true;
    },
    // 更换面试人员
    replaceFunc(rowData) {
      this.replaceInterviewerDialogVisible = true;
      this.replaceInterviewerRowData = rowData;
    },
    // 是否展示行内按钮
    showRowBtn(rowData, flag) {
      let list = [];
      if (flag == "arrangeSingle") {
        list = ["4", "6", "8", "10", "15", "16"];
      }
      if (flag == "other") {
        list = ["5", "6", "7", "8", "9", "10", "15", "16"];
      }
      if (flag == "replace") {
        list = ["5", "7", "9"];
      }
      return list.some((item) => item == rowData.lifeNode);
    },
    // 招募状态修改
    editStateSingleFunc(rowData) {
      this.editStateRowData = [rowData];
      this.editStateDialogVisible = true;
    },
    // 人员招募状态修改
    editStateFunc() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning("请先选择数据");
        return;
      }
      if (this.multipleSelection.length > 1) {
        this.$message.error("一次只能操作一个人员");
        return;
      }
      this.editStateRowData = this.multipleSelection;
      this.editStateDialogVisible = true;
    },
    // 其他操作
    otherFunc(rowData) {
      this.operateDialogVisible = true;
      this.operateRowData = rowData;
      console.log(rowData, "其他操作");
    },
    // 查看详情模块部分中点击‘返回’按钮执行的方法
    backFunc() {
      this.show = true;
    },
    // 查询
    searchFunc() {
      // 点击搜索时，要将页码数重置为1，因为查询的是从第一页开始的数据
      this.queryParams.pageNum = 1;
      // 调用查询获取表格数据的方法
      this.queryDataFunc();
    },

    // 重置
    resetFunc() {
      Object.keys(this.queryParams).forEach((item) => {
        this.queryParams[item] = "";
      });
      this.queryParams.pageType = this.currentRouteType;
      this.queryParams.stepType = "1";
      this.queryParams.organCodes = [];
      this.queryParams.pageNum = 1;
      this.queryParams.pageSize = 20;
      this.queryDataFunc("init");
    },
    // 人员安排
    arrangeFunc() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning("请先选择数据");
        return;
      }
      // 提取所有选中数据的机构编号
      const areaCodes = this.multipleSelection.map((item) => item.areaCode);
      // 创建去重后的机构编号列表
      const uniqueAreaCodes = Array.from(new Set(areaCodes));

      if (uniqueAreaCodes.length > 1) {
        this.$message.error("只能针对同一个机构的可分配的人员进行安排");
        return;
      }
      let showArrangeDialog = true;
      this.multipleSelection.forEach((item) => {
        if (!this.showRowBtn(item.lifeNode, "arrangeSingle")) {
          this.$message.error(
            "候选人[" + item.accountName + "]当前阶段已不能进行人员安排"
          );
          showArrangeDialog = false;
        }
      });
      if (showArrangeDialog) {
        this.arrangeSingRowData = this.multipleSelection;
        this.arrangeDialogVisible = true;
      }
    },
    // 人员导出
    exportFunc() {
      const {
        organCodes,
        certType,
        certCode,
        accountName,
        accountMobile,
        recomAgent,
        stepType,
        lifeNodes,
        dateRange,
      } = this.queryParams;
      let data = {
        organCodes: organCodes,
        certType: certType,
        certCode: certCode,
        accountName: accountName,
        accountMobile: accountMobile,
        recomAgent: recomAgent,
        stepType: stepType,
        lifeNodes: lifeNodes,
        startTime: dateRange[0] || "",
        endTime: dateRange[1] || "",
        excelTitle: "候选人清单导出",
      };
      if (dateRange[0]) {
        data.startTime = dateRange[0] + " 00:00:00";
      }
      if (dateRange[1]) {
        data.endTime = dateRange[1] + " 23:59:59";
      }
      api.post(url.exportAccount, data, (res) => {
        if (res.result.isSuccess) {
          console.log(res.data, "exportFunc");
          const elink = document.createElement("a");
          elink.download = "候选人清单导出.xlsx";
          console.log(this.$downloadUrl + res.data.fileId, "=====");
          elink.href = this.$downloadUrl + res.data.fileId;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message({
            type: "error",
            message: res.error,
          });
        }
      });
    },
    operateSingleFunc(rowData, btnType) {
      this.operateTitle =
        btnType == "return"
          ? "信息退回"
          : this.currentRouteType == "2"
          ? "信息确认"
          : "信息通过";
      this.reInterviewRowData = [rowData];
      this.reInterviewBtnType = btnType;
      this.reInterviewDialogVisible = true;
    },
    // 机构负责人确认/分公司审核 批量退回
    batchOperateFunc(type) {
      this.operateTitle =
        type == "return"
          ? "信息退回"
          : this.currentRouteType == "2"
          ? "信息确认"
          : "信息通过";

      let step = "";
      if (this.currentRouteType == "2") {
        step = "11";
      } else {
        step = "13";
      }
      if (this.multipleSelection.length === 0) {
        this.$message.warning("请先选择数据");
        return;
      }
      const stepCodes = this.getUniqueStepCodes(this.multipleSelection, step);
      const uniqueAreaCodes = [...new Set(stepCodes)];
      if (uniqueAreaCodes.length == 0) {
        this.$message.error(
          `只有${
            step == "11" ? "待机构确认" : "待分公司审核"
          }的候选人才能进行该操作。`
        );
        return;
      }
      this.reInterviewRowData = this.multipleSelection;
      this.reInterviewBtnType = type;
      this.reInterviewDialogVisible = true;
      console.log(type, "批量操作");
    },
    getUniqueStepCodes(selection, step) {
      if (!Array.isArray(selection)) {
        throw new Error("multipleSelection must be an array");
      }
      return selection
        .filter((item) => item && item.lifeNode === step) // 过滤掉无效项
        .map((item) => item.lifeNode);
    },
    //获取coookie中得token数据的方法
    getCookieData() {
      // 先重置清空变量，防止数据有缓存
      this.token = "";
      let arr,
        reg = new RegExp("(^| )" + "jtl" + "=([^;]*)(;|$)"),
        obj = document.cookie.match(reg);
      obj instanceof Array && (arr = obj);
      this.token = arr && unescape(arr[2]);
    },

    // 获取机构下拉菜单数据集合的方法
    getManageComNameSelectDataFunc() {
      api.post(url.getOrgListService, {}, (res) => {
        if (res.result.isSuccess) {
          this.manageComNameOptions = res.data;
          console.log(this.manageComNameOptions, "manageComNameOptions数据");
        } else {
          this.$message({
            type: "error",
            message: res.error,
          });
        }
      });
    },

    // 查询获取表格数据的方法
    queryDataFunc(state = "") {
      if (state == "init") {
        if (this.currentRouteType == "2") {
          this.queryParams.lifeNodes = ["11"];
        } else if (this.currentRouteType == "3") {
          this.queryParams.lifeNodes = ["13"];
        } else if (this.currentRouteType == "4") {
          this.queryParams.lifeNodes = ["14", "15"];
        } else {
          this.queryParams.lifeNodes = [];
        }
      }
      const {
        organCodes,
        certType,
        certCode,
        accountName,
        accountMobile,
        recomAgent,
        stepType,
        lifeNodes,
        dateRange,
        pageNum,
        pageSize,
      } = this.queryParams;
      let data = {
        organCodes: organCodes,
        certType: certType,
        certCode: certCode,
        accountName: accountName,
        accountMobile: accountMobile,
        recomAgent: recomAgent,
        stepType: stepType,
        lifeNodes: lifeNodes,
        startTime: "",
        endTime: "",
        pageNum: pageNum,
        pageSize: pageSize,
        pageType: this.currentRouteType,
      };
      if (dateRange && dateRange.length > 0) {
        if (dateRange[0]) {
          data.startTime = dateRange[0] + " 00:00:00";
        }
        if (dateRange[1]) {
          data.endTime = dateRange[1] + " 23:59:59";
        }
      }

      // 调用查询表格数据的接口，获取数据
      api.post(url.getAccountListForPC, data, (res) => {
        if (res.result.isSuccess) {
          this.tableData = res.data.rows;
          this.total = ~~res.data.total;
        } else {
          this.$message({
            type: "error",
            message: res.result.error,
          });
        }
        // 关闭表格加载遮罩层
        this.loading = false;
      });
    },

    // 切换选择的机构数据的方法
    handleChange(value) {
      // 将选择的T2机构的机构代码，赋值给对应的变量
      this.queryParams.t2 = value[0];
      // 将选择的T3机构的机构代码，赋值给对应的变量
      this.queryParams.t3 = value[1];
    },

    // 切换当前页码
    handleCurrentChange(val) {
      // 切换页码后，将当前的页码数赋值给变量
      this.queryParams.pageNum = val;
      // 调用查询获取表格数据的方法
      this.queryDataFunc();
    },

    //选择时间范围时，将所选时间范围，分别赋值给起始时间与结束时间的方法
    changeDate(date, sum) {
      if (date != null) {
        switch (sum) {
          case 1:
            this.dateRange[0] = date + " 00:00:00";
            break;
          case 2:
            this.dateRange[1] = date + " 23:59:59";
            break;
        }
      } else {
        this.dateRange = [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.officeSaff-container {
  /deep/ .container {
    width: calc(100% - 30px);
    margin: 0 auto;
    margin-top: 15px;
    padding-bottom: 15px;
    background: #ffffff;
    height: calc(100vh - 110px);
    display: flex;
    flex-direction: column;
  }
  .detail-container {
    position: relative;
    padding: 20px;
  }
  .el-header {
    height: auto !important;

    .el-row {
      margin-top: 20px;
    }

    .el-input {
      width: 210px;
    }
  }

  .table-container {
    margin-top: 10px;
    flex: 1;
    overflow: hidden;
    position: relative;
  }

  .el-main {
    flex: 1;
    padding: 0;
    overflow: hidden;
    
    /deep/ .el-table {
      height: 100%;
    }
    
    /deep/ .el-table__body-wrapper {
      overflow-y: auto;
      overflow-x: auto;
    }
    
    /deep/ thead {
      .el-table__cell {
        background: #f5f7fa;
      }
    }
  }

  .el-footer {
    text-align: right;
  }

  button {
    cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/recruit/officeSaff/list.vue